/* FurAway B2B – interaktioner. Inga beroenden. */
(function(){
  if (window.__faInit) return; window.__faInit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, r){ return (r || document).querySelector(s); }
  function $$(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function fmt(n){ return Math.round(n).toLocaleString('sv-SE'); }

  /* Reveal vid scroll */
  function reveals(root){
    var els = $$('[data-fa-reveal], .fa-split, .fa-steps', root);
    if (!('IntersectionObserver' in window) || reduce){ els.forEach(function(e){ e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function(e){ io.observe(e); });
  }

  /* Räknare */
  function counters(root){
    var els = $$('[data-fa-count]', root);
    if (!els.length) return;
    var run = function(el){
      var to = parseFloat(el.getAttribute('data-fa-count')) || 0;
      var dec = parseInt(el.getAttribute('data-fa-dec') || '0', 10);
      if (reduce){ el.textContent = to.toLocaleString('sv-SE', { minimumFractionDigits: dec, maximumFractionDigits: dec }); return; }
      var t0 = null, dur = 1600;
      function step(t){
        if (!t0) t0 = t;
        var p = Math.min(1, (t - t0) / dur);
        var e = 1 - Math.pow(1 - p, 4);
        el.textContent = (to * e).toLocaleString('sv-SE', { minimumFractionDigits: dec, maximumFractionDigits: dec });
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      setTimeout(function(){ el.textContent = to.toLocaleString('sv-SE', { minimumFractionDigits: dec, maximumFractionDigits: dec }); }, dur + 400);
    };
    if (!('IntersectionObserver' in window)){ els.forEach(run); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting){ run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.4 });
    els.forEach(function(e){ io.observe(e); });
  }

  /* Header: bakgrund vid scroll + mobilmeny */
  function header(){
    var h = $('.fa-header'); if (!h || h.__faH) return; h.__faH = true;
    var on = function(){ h.classList.toggle('is-scrolled', window.scrollY > 12); };
    on(); window.addEventListener('scroll', on, { passive: true });
    var b = $('.fa-header__burger', h);
    if (b){
      b.addEventListener('click', function(){
        var open = h.classList.toggle('is-open');
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      $$('.fa-header__drawer a', h).forEach(function(a){ a.addEventListener('click', function(){ h.classList.remove('is-open'); }); });
    }
  }

  /* Mjuk scroll till ankare, med hänsyn till headern */
  function anchors(){
    document.addEventListener('click', function(e){
      var a = e.target.closest && e.target.closest('a[href*="#"]');
      if (!a) return;
      var href = a.getAttribute('href');
      var hash = href.slice(href.indexOf('#'));
      if (hash.length < 2) return;
      var path = href.split('#')[0];
      if (path && path !== location.pathname && path !== location.href.split('#')[0] && !document.getElementById(hash.slice(1))) return;
      var t = document.getElementById(hash.slice(1));
      if (!t) return;
      e.preventDefault();
      var y = t.getBoundingClientRect().top + window.scrollY - 84;
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
      if (history.replaceState) history.replaceState(null, '', hash);
    });
  }

  /* 3D-lutning + ljus som följer musen */
  function tilt(root){
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    $$('[data-fa-tilt]', root).forEach(function(card){
      var wrap = card.parentElement;
      wrap.addEventListener('mousemove', function(e){
        var r = wrap.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        card.style.transform = 'rotateY(' + ((x - .5) * 10) + 'deg) rotateX(' + ((.5 - y) * 8) + 'deg)';
        card.style.setProperty('--mx', (x * 100) + '%');
        card.style.setProperty('--my', (y * 100) + '%');
      });
      wrap.addEventListener('mouseleave', function(){ card.style.transform = ''; });
    });
  }

  /* Magnetiska knappar */
  function magnets(root){
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    $$('[data-fa-magnet]', root).forEach(function(b){
      b.addEventListener('mousemove', function(e){
        var r = b.getBoundingClientRect();
        b.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * .18) + 'px,' + ((e.clientY - r.top - r.height / 2) * .28) + 'px)';
      });
      b.addEventListener('mouseleave', function(){ b.style.transform = ''; });
    });
  }

  /* Sticky story */
  function story(root){
    $$('.fa-story', root).forEach(function(s){
      var steps = $$('.fa-story__step', s), imgs = $$('.fa-story__img', s), bars = $$('.fa-story__progress span', s);
      if (!steps.length) return;
      var set = function(i){
        steps.forEach(function(st, k){ st.classList.toggle('is-active', k === i); });
        imgs.forEach(function(im, k){
          var on = k === i; im.classList.toggle('is-active', on);
          var v = im.querySelector('video');
          if (v){ if (on){ if (v.dataset.src && !v.getAttribute('src')) v.src = v.dataset.src; v.play && v.play().catch(function(){}); } else { v.pause && v.pause(); } }
        });
        bars.forEach(function(b, k){ b.classList.toggle('is-done', k <= i); });
      };
      set(0);
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if (en.isIntersecting) set(steps.indexOf(en.target)); });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function(st){ io.observe(st); });
    });
  }

  /* Före/efter */
  function beforeAfter(root){
    $$('.fa-ba__frame', root).forEach(function(f){
      var r = $('.fa-ba__range', f);
      if (!r) return;
      var upd = function(){ f.style.setProperty('--pos', r.value + '%'); };
      r.addEventListener('input', upd); upd();
      if (reduce || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function(en){
        if (!en[0].isIntersecting) return; io.disconnect();
        var t0 = null;
        function a(t){
          if (!t0) t0 = t; var p = (t - t0) / 1800; if (p > 1) p = 1;
          var v = 50 + Math.sin(p * Math.PI * 2) * 22 * (1 - p);
          r.value = v; upd(); if (p < 1) requestAnimationFrame(a);
        }
        requestAnimationFrame(a);
      }, { threshold: .5 });
      io.observe(f);
    });
  }

  /* Marginalkalkylator */
  function calc(root){
    $$('[data-fa-calc]', root).forEach(function(c){
      var buy = $('[name="buy"]', c), rrp = $('[name="rrp"]', c), qty = $('[name="qty"]', c);
      var vat = parseFloat(c.getAttribute('data-vat') || '25');
      var outs = {};
      $$('[data-out]', c).forEach(function(o){ outs[o.getAttribute('data-out')] = o; });
      var fill = function(inp){
        var p = (inp.value - inp.min) / (inp.max - inp.min) * 100;
        inp.style.setProperty('--p', p + '%');
      };
      var shown = {};
      var tween = function(key, val, suffix){
        var el = outs[key]; if (!el) return;
        var from = shown[key] == null ? 0 : shown[key]; shown[key] = val;
        if (reduce || from === val){ el.textContent = fmt(val) + (suffix || ''); return; }
        var t0 = null;
        function s(t){ if (!t0) t0 = t; var p = Math.min(1, (t - t0) / 420); var e = 1 - Math.pow(1 - p, 3);
          el.textContent = fmt(from + (val - from) * e) + (suffix || ''); if (p < 1) requestAnimationFrame(s); }
        requestAnimationFrame(s);
      };
      var run = function(){
        [buy, rrp, qty].forEach(fill);
        var b = parseFloat(buy.value), r = parseFloat(rrp.value), q = parseFloat(qty.value);
        var exVat = r / (1 + vat / 100);
        var profit = exVat - b;
        var margin = exVat > 0 ? profit / exVat * 100 : 0;
        if (outs.buy) outs.buy.textContent = fmt(b) + ' kr';
        if (outs.rrp) outs.rrp.textContent = fmt(r) + ' kr';
        if (outs.qty) outs.qty.textContent = fmt(q) + ' st';
        tween('month', profit * q * 4.33, ' kr');
        tween('year', profit * q * 52, ' kr');
        tween('unit', profit, ' kr');
        if (outs.margin) outs.margin.textContent = Math.round(margin) + ' %';
        if (outs.markup) outs.markup.textContent = (b > 0 ? (exVat / b).toFixed(1).replace('.', ',') : '–') + 'x';
      };
      [buy, rrp, qty].forEach(function(i){ i.addEventListener('input', run); });
      run();
    });
  }

  /* Produktgalleri (slider, inget rutnät) */
  function gallery(root){
    $$('[data-fa-gal]', root).forEach(function(g){
      var track = $('.fa-gal__track', g), slides = $$('.fa-gal__slide', g), thumbs = $$('.fa-gal__thumbs button', g), count = $('.fa-gal__count', g);
      if (!track || !slides.length) return;
      var cur = 0;
      var go = function(i){ i = (i + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); };
      var mark = function(i){
        cur = i;
        thumbs.forEach(function(t, k){ t.classList.toggle('is-active', k === i); });
        if (count) count.textContent = (i + 1) + ' / ' + slides.length;
        slides.forEach(function(s, k){ var v = s.querySelector('video'); if (v){ if (k === i) v.play && v.play().catch(function(){}); else v.pause && v.pause(); } });
      };
      var t;
      track.addEventListener('scroll', function(){ clearTimeout(t); t = setTimeout(function(){ mark(Math.round(track.scrollLeft / track.clientWidth)); }, 60); }, { passive: true });
      thumbs.forEach(function(b, k){ b.addEventListener('click', function(){ go(k); }); });
      var p = $('[data-prev]', g), n = $('[data-next]', g);
      if (p) p.addEventListener('click', function(){ go(cur - 1); });
      if (n) n.addEventListener('click', function(){ go(cur + 1); });
      mark(0);
    });
  }

  /* Videosegment: spelar bara data-start till data-end i loop */
  function seg(v){
    if (v.__faSeg) return; v.__faSeg = true;
    var s = parseFloat(v.getAttribute('data-start') || '0'), e = parseFloat(v.getAttribute('data-end') || '0');
    if (!e) return;
    var jump = function(){ try { v.currentTime = s; } catch(x){} };
    v.addEventListener('loadedmetadata', jump);
    v.addEventListener('timeupdate', function(){ if (v.currentTime >= e || v.currentTime < s - 0.4) jump(); });
  }
  function segments(root){ $$('video[data-start]', root).forEach(seg); }

  /* Videor spelas bara när de syns */
  function lazyVideos(root){
    var vids = $$('video[data-fa-autoplay]', root);
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)){ vids.forEach(function(v){ if (v.dataset.src && !v.getAttribute('src')) v.src = v.dataset.src; v.play && v.play().catch(function(){}); }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        var v = en.target;
        if (en.isIntersecting){
          if (v.dataset.src && !v.getAttribute('src')){ v.src = v.dataset.src; }
          if (!v.closest('.fa-story__img') || v.closest('.fa-story__img.is-active')) v.play && v.play().catch(function(){});
        } else v.pause && v.pause();
      });
    }, { threshold: .15 });
    vids.forEach(function(v){ io.observe(v); });
  }

  /* Mobil fast CTA – syns efter hero, döljs vid formuläret */
  function mobileCta(){
    var m = $('.fa-mcta'); if (!m) return;
    var form = document.getElementById('ansok');
    var on = function(){
      var past = window.scrollY > window.innerHeight * .8;
      var nearForm = false;
      if (form){ var r = form.getBoundingClientRect(); nearForm = r.top < window.innerHeight && r.bottom > 0; }
      m.classList.toggle('is-on', past && !nearForm);
    };
    on(); window.addEventListener('scroll', on, { passive: true });
  }

  /* Källa: sparar första besökta sida, hänvisning och UTM för sessionen */
  var SRC = (function(){
    var k = 'fa_src', d = null;
    try { d = JSON.parse(sessionStorage.getItem(k) || 'null'); } catch(e) {}
    if (!d){
      var q = new URLSearchParams(location.search), utm = [];
      ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','fbclid'].forEach(function(n){ if (q.get(n)) utm.push(n + '=' + q.get(n)); });
      d = { landing: location.pathname, ref: document.referrer || 'Direkt / okänd', utm: utm.join(' | ') || '–' };
      try { sessionStorage.setItem(k, JSON.stringify(d)); } catch(e) {}
    }
    return d;
  })();

  /* Formulär: källa + förval från knappar (t.ex. "Gratis testorder") */
  function forms(root){
    $$('[data-fa-form]', root).forEach(function(f){
      var set = function(n, v){ var i = f.querySelector('[data-fa-src="' + n + '"]'); if (i) i.value = v; };
      set('page', location.pathname); set('ref', SRC.ref); set('utm', SRC.utm); set('landing', SRC.landing);
      var pick = function(key){ var b = f.querySelector('input[data-key="' + key + '"]'); if (b) b.checked = true; };
      try { var pre = sessionStorage.getItem('fa_prefill'); if (pre){ pick(pre); sessionStorage.removeItem('fa_prefill'); } } catch(e) {}
      $$('a[data-fa-prefill]', document).forEach(function(a){
        if (a.__faPre) return; a.__faPre = true;
        a.addEventListener('click', function(){
          var key = a.getAttribute('data-fa-prefill');
          if (!key) return;
          pick(key);
          try { sessionStorage.setItem('fa_prefill', key); } catch(e) {}
        });
      });
    });
  }

  function init(root){
    segments(root); reveals(root); counters(root); tilt(root); magnets(root); story(root); beforeAfter(root); calc(root); gallery(root); lazyVideos(root); forms(root);
  }

  document.documentElement.classList.remove('fa-no-js');
  function boot(){ header(); anchors(); mobileCta(); init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* Temaredigeraren: kör om när en sektion laddas om */
  document.addEventListener('shopify:section:load', function(e){ init(e.target); if (e.target.querySelector('.fa-header')) header(); });
})();
